import {FlatpickrFn} from "flatpickr/dist/types/instance";
import {AbstractItem} from "./abstract-task";

export class QueueTask extends AbstractItem {
  constructor(item: HTMLElement, flatpickr: FlatpickrFn, type: string) {
    super(item, flatpickr, type);
  }

  setDeadlineStatusClass(status: string) {
    if (status === `burn`) {
      this.openElement.classList.remove(`task__day--current`);
      this.openElement.classList.add(`task__day--burn`);
    } else {
      this.openElement.classList.remove(`task__day--burn`);
      this.openElement.classList.add(`task__day--current`);
    }
  }
}
